import { __decorate } from "tslib";
import 'form-request-submit-polyfill';
import 'element-internals-polyfill';
import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import { button as buttonStyles } from './styles/button.js';
import { ButtonType } from './enums/button-type.js';
import { Size } from './enums/size.js';
import { Variant } from './enums/variant.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { Large, ...ButtonSize } = Size;
export { ButtonType, Variant as ButtonVariant, ButtonSize };
let ViedocButton = class ViedocButton extends LitElement {
    constructor() {
        super();
        this.disabled = false;
        this.ariaLabel = '';
        this.size = ButtonSize.Medium;
        this.type = ButtonType.Button;
        this.variant = Variant.Neutral;
        this._internals = this.attachInternals();
        this._internals.role = 'button';
        this._handleSubmitClick = this._handleSubmitClick.bind(this);
    }
    _handleSubmitClick() {
        var _a;
        (_a = this._internals.form) === null || _a === void 0 ? void 0 : _a.requestSubmit();
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.type === 'submit') {
            this.addEventListener('click', this._handleSubmitClick);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.type === 'submit') {
            this.removeEventListener('click', this._handleSubmitClick);
        }
    }
    render() {
        const classNames = classMap({
            button: true,
            [`button--${this.size}`]: true,
            [`button--${this.variant}`]: true,
        });
        return html `
      <button
        aria-label=${this.ariaLabel}
        type=${this.type}
        class=${classNames}
        ?disabled=${this.disabled}
      >
        <span class="button__prefix"><slot name="prefix"></slot></span>
        <span class="button__label">
          <slot></slot>
          <span class="button__subtitle"><slot name="subtitle"></slot></span>
        </span>
        <span class="button__suffix"><slot name="suffix"></slot></span>
      </button>
    `;
    }
};
ViedocButton.shadowRootOptions = {
    ...LitElement.shadowRootOptions,
    delegatesFocus: true,
};
ViedocButton.formAssociated = true;
ViedocButton.styles = [buttonStyles];
__decorate([
    property({ type: Boolean, reflect: true })
], ViedocButton.prototype, "disabled", void 0);
__decorate([
    property({ type: String, attribute: 'aria-label' })
], ViedocButton.prototype, "ariaLabel", void 0);
__decorate([
    property({ type: String })
], ViedocButton.prototype, "size", void 0);
__decorate([
    property({ type: String })
], ViedocButton.prototype, "type", void 0);
__decorate([
    property({ type: String })
], ViedocButton.prototype, "variant", void 0);
__decorate([
    property({ type: ElementInternals })
], ViedocButton.prototype, "_internals", void 0);
ViedocButton = __decorate([
    customElement('viedoc-button')
], ViedocButton);
export { ViedocButton };
